export default __webpack_public_path__ + "assets/png/4972e04c0bc1522bc5d040627baddb6a.png";